import { Route } from '@angular/router';
import { CommandeConfirmComponent } from './commande-confirm.component';

export const CommandeConfirmRouting: Route = {
  path: "confirmation",
  component: CommandeConfirmComponent,
  data: {
    breadcrumb: "Confirmer une commande"
  }
}
